export default __webpack_public_path__ + "static/media/ew_slide.681a05d3.jpg";